import {
  format,
  isPast as isPastDateFns,
} from 'date-fns';

import {
  enUS as enLocale,
  de as deLocale,
  fr as frLocale,
} from 'date-fns/esm/locale';

import { currentLanguage } from '../i18n';

const locales = {
  de: deLocale,
  en: enLocale,
  fr: frLocale,
};

const formatLocale = {
  de: 'dd.MM.yyyy',
  en: 'MM/dd/yyyy',
  fr: 'dd/MM/yyyy',
};

const formatTimeLocale = {
  de: 'HH:mm',
  en: 'hh:mm aaa',
  fr: 'hh:mm S',
};

const shortDaysByLocale = {
  de: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  en: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  fr: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
};

export const formatDate = (date) => format(Date.parse(date), formatLocale[currentLanguage()], {
  locale: locales[currentLanguage()],
});

export const formatTime = (date) => format(Date.parse(date), formatTimeLocale[currentLanguage()], {
  locale: locales[currentLanguage()],
});

export const formatWeekDay = (date) => format(date, 'dddd', {
  locale: locales[currentLanguage()],
})[0];

export const shortDays = () => shortDaysByLocale[currentLanguage()];

export const isPast = (date) => isPastDateFns(date);
